angular.module('app.boards', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging'])
    .config(['$routeProvider', ($routeProvider) => {
      $routeProvider.when('/boards/:board_type', {
        template: require('./boards.html'),
        controller: 'boardsCtrl',
      }).when('/boards/:board_type/add', {
        template: require('./add.html'),
        controller: 'boardAddCtrl',
      }).when('/boards/:board_type/:tb_notice_id', {
        template: require('./board.html'),
        controller: 'boardCtrl',
      }).when('/boards/:board_type/:tb_notice_id/modify', {
        template: require('./modify.html'),
        controller: 'boardModifyCtrl',
      });
    }])
    .controller('boardsCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService) => {
      $rootScope.mainmenu = 'notices';
      $rootScope.menu = $routeParams.board_type;

      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      const type = $routeParams.board_type;
      if (type === 'event') {
        $scope.title = $translate.instant('이벤트');
      } else if (type === 'notice') {
        $scope.title = $translate.instant('공지사항');
      }
      $scope.type = type;
      $scope.total_count = 0;
      $scope.query = '';


      $resource(`${APIURL}/admin/boards/:type`, { type }).get({ q: $scope.query }, (data) => {
        $scope.boards = data.boards;
        $scope.total_count = data.total_count;
        console.log(data);
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
      $scope.paging = (page) => {
        $resource(`${APIURL}/admin/boards/:type`, { type }).get({ page: page - 1, q: $scope.query },
                (data) => {
                  console.log(data);
                  $scope.boards = data.boards;
                  $scope.total_count = data.total_count;
                }, (err) => {
                  console.error(err);
                  if (err.data && err.data.msg) {
                    alert(err.data.msg);
                  } else {
                    alert($translate.instant('알수 없는 에러 입니다.'));
                  }
                });
      };
      $scope.gotoDetail = (board) => {
        $location.path(`/boards/${type}/${board.ID}`);
      };
    })
    .controller('boardAddCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService, Upload) => {
      $rootScope.mainmenu = 'notices';
      $rootScope.menu = $routeParams.board_type;
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      const type = $routeParams.board_type;
      if (type === 'event') {
        $scope.title = $translate.instant('이벤트');
      } else if (type === 'notice') {
        $scope.title = $translate.instant('공지사항');
      }
      $scope.type = type;
      $scope.notice = { TITLE: '', CONT: '', group: '1', day: '10' };
      $scope.medias = [];
      $scope.isLoading = false;

      $scope.submit = () => {
        if ($scope.isLoading) {
          return;
        }
        for (let idx = 0; idx < $scope.medias.length; idx += 1) {
          const url = $scope.medias[idx];
          if (url.length < 1) {
            alert($translate.instant('이미지를 업로드해주세요.'));
            return;
          }
        }
        if ($scope.notice.TITLE.length < 1) {
          alert($translate.instant('제목을 입력해주세요.'));
          return;
        }
        if ($scope.notice.CONT.length < 1) {
          alert($translate.instant('내용을 입력해주세요.'));
          return;
        }
        $scope.notice.URLS = $scope.medias;
        $scope.notice.MAIN_POPUP_YN = $scope.notice.MAIN_POPUP_YN ? 'Y' : 'N';
        $scope.isLoading = true;
        $resource(`${APIURL}/admin/boards/:type`, { type }).save($scope.notice, () => {
          $location.path(`/boards/${type}`);
        }, (err) => {
          $scope.isLoading = false;
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.remove = (url) => {
        $scope.medias = $scope.medias.filter(item => item != url); // eslint-disable-line eqeqeq
      };

      $scope.add = () => {
        $scope.medias.push('');
      };

      $scope.upload = (media, files, index) => {
        if (files && files.length) {
          const file = files[0];
          Upload.upload({
            url: `${APIURL}/admin/file/notice`,
            file,
          }).progress((evt) => {
            const progressPercentage = parseInt((100.0 * evt.loaded) / evt.total, 10);
            console.log(`progress: ${progressPercentage}% ${evt.config.file.name}`);
          }).success((data, status, headers, config) => {
            console.log(`file ${config.file.name}uploaded. Response: ${data}`);
            console.log(data);
            media = data.url;
            $scope.medias[index] = data.url;
            alert($scope.medias);
          });
        }
      };
    })
    .controller('boardCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService) => {
      $rootScope.mainmenu = 'notices';
      $rootScope.menu = $routeParams.board_type;
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      const type = $routeParams.board_type;
      const tbNoticeId = $routeParams.tb_notice_id;
      $scope.query = '';
      if (type === 'event') {
        $scope.title = $translate.instant('이벤트');
      } else if (type === 'notice') {
        $scope.title = $translate.instant('공지사항');
      }

      $resource(`${APIURL}/admin/boards/:type/:tb_notice_id`, { type, tb_notice_id: tbNoticeId }).get({ q: $scope.query }, (data) => {
        $scope.notice = data.board;
        $scope.medias = data.board.URLS;
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });

      $scope.delBoard = () => {
        if ($window.confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          $resource(`${APIURL}/admin/boards/:type/:tb_notice_id`, { type, tb_notice_id: tbNoticeId }).delete(() => {
            alert($translate.instant('삭제되었습니다'));
            $location.path(`/boards/${type}`);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        }
      };

      $scope.gotoModify = () => {
        $location.path(`/boards/${type}/${tbNoticeId}/modify`);
      };

      $scope.gotoList = () => {
        $location.path(`/boards/${type}`);
      };
    })
    .controller('boardModifyCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService, Upload) => {
      $rootScope.mainmenu = 'notices';
      $rootScope.menu = $routeParams.board_type;
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      const type = $routeParams.board_type;
      const tbNoticeId = $routeParams.tb_notice_id;
      $scope.query = '';
      if (type === 'event') {
        $scope.title = $translate.instant('이벤트');
      } else {
        $scope.title = $translate.instant('공지사항');
      }

      $resource(`${APIURL}/admin/boards/:type/:tb_notice_id`, { type, tb_notice_id: tbNoticeId }).get({ q: $scope.query }, (data) => {
        $scope.notice = data.board;
        $scope.notice.MAIN_POPUP_YN_TF = $scope.notice.MAIN_POPUP_YN === 'Y';
        if ($scope.notice.URLS === null) {
          $scope.notice.URLS = [];
        }
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });

      $scope.confirm = () => {
        $scope.notice.MAIN_POPUP_YN = $scope.notice.MAIN_POPUP_YN_TF ? 'Y' : 'N';
        $resource(`${APIURL}/admin/boards/:type/:tb_notice_id`, { type, tb_notice_id: tbNoticeId }).save($scope.notice, () => {
          $location.path(`/boards/${type}/${tbNoticeId}`);
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.remove = (url) => {
        $scope.notice.URLS = $scope.notice.URLS.filter(item => item != url); // eslint-disable-line eqeqeq
      };

      $scope.add = () => {
        $scope.notice.URLS.push('');
      };

      $scope.upload = (url, files, index) => {
        console.log(files);
        if (files && files.length) {
          const file = files[0];
          Upload.upload({
            url: `${APIURL}/admin/file/notice`,
            file,
          }).progress((evt) => {
            const progressPercentage = parseInt((100.0 * evt.loaded) / evt.total, 10);
            console.log(`progress: ${progressPercentage}% ${evt.config.file.name}`);
          }).success((data) => {
            url = data.url;
            $scope.notice.URLS[index] = data.url;
          });
        }
      };
    });



// WEBPACK FOOTER //
// ./src/app/boards/boards.js